// extracted by mini-css-extract-plugin
export default {"item":"feed-order-element_item__v-EAU","info":"feed-order-element_info__vLF4v","price":"feed-order-element_price__CZtQx","icon":"feed-order-element_icon__7pLX4"};